/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { MemberItems, ChatItems, MessageItems } from "../../../../../types/Applications";
import { fetchChatMemberAsync, setChats, setSelectedUser } from "../../../../../reduxToolkit/reducers/chatSlice";
import { dynamicImage } from "../../../../../utils";
import MessageInput from "./MessageInput";
import { Image } from "../../../../../coreComponents/Image";

//This component is responsible for rendering the chat interface. It manages fetching chat data, handling user selection, and displaying chat messages.
const ChatBody = () => {
  // Reference to the bottom of the chat for auto-scrolling
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const [scroll, setScroll] = useState(0);
  const { allMembers, chats, selectedUser, currentUser } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();


 // Fetches the chat for the current user from the chat list, determines the selected user based on chat history and updates the Redux store with the chat data.
  const fetchChatAsync = () => {
    if (chats.length > 0) {
      const currentUserId = 0;
      const chat = chats.filter((x: ChatItems) => x.users.includes(currentUserId));
      const selectedUser = chats[0].users.find((x: number) => x !== currentUserId);
      const oneSelect = allMembers.find((x: MemberItems) => x.id === selectedUser);
      if (allMembers.length > 0) {
        dispatch(setChats(chat));
        dispatch(setSelectedUser(oneSelect));
      }
      if (allMembers.length > 0) {
        return allMembers.find((x: MemberItems) => x.id === selectedUser);
      }
    }
  };

  // Fetches chat members from the backend and calls `fetchChatAsync` to set the initial chat.
  useEffect(() => {
    dispatch(fetchChatMemberAsync());
    fetchChatAsync();
    setScroll(1);
  }, [dispatch, allMembers.length, chats.length]);

  // Auto-scrolls to the bottom of the chat when new messages are received
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats, scroll]);

  //Finds the chat between the current user and the selected user.
  const selectedChat = allMembers && chats && selectedUser ? chats.find((x: ChatItems) => x.users.includes(currentUser?.id as number) && x.users.includes(selectedUser.id)) : null;

  return (
    <div className="right-sidebar-Chats">
      <div className="msger">
        <div className="msger-chat">
          {/* Mapping through selectedChat to display chat messages if available */}
          {selectedChat && selectedChat.messages.length > 0 ? (
            selectedChat.messages.map((item: MessageItems, id: number) => {
              const participators = allMembers.find((x: MemberItems) => x.id === item.sender);
              return (
                <div className={`msg ${item.sender === currentUser?.id ? "right" : "pull-right left"}-msg`} key={id}>
                  <Image src={dynamicImage(`${item.sender === currentUser?.id ? participators?.image : selectedUser?.image}`)} className="rounded-circle img-30 h-auto" alt="user" />
                  <div className="msg-bubble mx-2">
                    <div className="msg-info">
                      <div className="msg-info-name">{item.sender === currentUser?.id ? participators?.name : selectedUser?.name}</div>
                      <div className="msg-info-time">{item.time}</div>
                    </div>
                    <div>{item.text}</div>
                  </div>
                </div>
              );
            })
          ) : (
            <Image className="img-fluid w-100" src={dynamicImage(`start-conversion.jpg`)} alt="start conversion" />
          )}
        </div>
        <MessageInput />
      </div>
    </div>
  );
};

export default ChatBody;